import React, { Fragment, useState } from 'react';
import { connect } from "react-redux";
import { useIntl } from 'react-intl';
import compose from 'recompose/compose';
import { arrayOf, bool, func, number, shape, string, array } from 'prop-types';
import { withStyles, Link } from '@material-ui/core';

import styles from './styles';
import { fetchApis } from "../../../../actions/products";
import {
  getApisListResults,
  getApisListTotalElements,
  getApisListTotalPages,
} from "../../../../reducers/products";
import ListContainer from "../../../list";
import {
  GRID_ROWS_PER_PAGE_DEFAULT_OPTION_24,
  GRID_ROWS_PER_PAGE_EXTRA_OPTIONS,
  ASSIGNED,
} from "../../../../constants";
import { getI18n, getI18nFormattedMessage } from "../../../../utils/intl";
import {
  FilterByText,
} from '../../../../pageComponents';


export const getAPIListColumns = (onApiClick) => [{
  id: 'name',
  label: getI18nFormattedMessage('label.api.name'),
  minWidth: 100,
  value: (item) => <Link onClick={() => onApiClick(item.apiUuid)}>{item.name}</Link>,
}];

export const Apis = (props) => {
  const {
    classes,
    productUuid,
    isLoading,
    apisList = [],
    totalElements,
    totalPages,
    onApiClick,
    selectedRows,
  } = props;

  const [filterByName, setFilterByName] = useState('');
  const [filterByNameApplied, setFilterByNameApplied] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION_24);
  const [page, setPage] = useState(0);
  const filterAssign = ASSIGNED;
  const intl = getI18n(useIntl());

  const onFilterByNameChange = (value) => {
    setFilterByName(value);
  };

  const onFilterByNameKeyPress = (e) => {
    if (e.key === 'Enter') {
      setFilterByNameApplied(true);
      setPage(0);
      props.fetchApis({
        uuid: productUuid, page: 0, name: filterByName, size: rowsPerPage, assign: filterAssign,
      });
    }
  };

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    props.fetchApis({
      uuid: productUuid, name: filterByName, page: newPage, size: rowsPerPage, assign: filterAssign,
    });
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    props.fetchApis({
      uuid: productUuid, name: filterByName, page: 0, size: newRowsPerPage, assign: filterAssign,
    });
  };

  const noResultsMessage = filterByNameApplied ?
    `${intl.getI18nMessage('label.apis.filter.no.results')}` :
    intl.getI18nMessage('label.product.apis.no.results');

  return (
    <>
      <ListContainer
        listPageId="product-details-spec-apis-list"
        isLoading={isLoading}
        showListHeader={false}
        pageClass={classes.listContent}
        pageBodyClass={classes.pageBodyClass}
        pageFilterAndSortClass={classes.pageFilterAndSortClass}
        selectedRows={selectedRows}
        filterAndSortContent={(
          <Fragment>
            <FilterByText
              id={'product-details-spec-apis-filter-by-name'}
              fieldContainerClass={classes.fieldContainer}
              name={intl.getI18nMessage('label.filter.by')}
              value={filterByName}
              placeholder={'Search APIs'}
              handleChange={onFilterByNameChange}
              onKeyPress={onFilterByNameKeyPress}
              hideLabel
            />
          </Fragment>
        )}
        columns={getAPIListColumns(onApiClick)}
        rows={apisList}
        noResultsMessage={noResultsMessage}
        page={page}
        count={totalElements}
        totalElements={totalElements}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={GRID_ROWS_PER_PAGE_EXTRA_OPTIONS}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        onChangePreviousPage={onChangePreviousPage}
        onChangeNextPage={onChangeNextPage}
      />
    </>
  )
};

Apis.propTypes = {
  classes: shape({}),
  productDetails: shape({}),
  isLoading: bool,
  totalPages: number,
  totalElements: number,
  apisList: arrayOf(shape({})),
  fetchApis: func,
  productUuid: string,
  isCurrentTab: bool,
  onApiClick: func,
  selectedRows: array,
};

const mapStateToProps = (state) => ({
  isLoading: false,
  apisList: getApisListResults(state),
  totalPages: getApisListTotalPages(state),
  totalElements: getApisListTotalElements(state),
});

const mapDispatchToProps = {
  fetchApis,
};
Apis.displayName = 'Apis';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Apis);
